import { action, observable } from 'mobx';
import { StoreExt } from '@utils/reactExt';

export class RecordStore extends StoreExt {
    @observable
    txrwebInstance: any | undefined;

    @action
    startRecord = async (pageTitle: string, forceStart: boolean = false, bizKey?: string): Promise<any> => {
        // @ts-ignore
        const txrwebInstance = new txrweb({
            privateKey: process.env.PRIVATE_KEY,
            pageTitle,
            forceStart,
            success: (bizId: string) => {
                console.log('========success==========', bizId);
            },
            error: (err: Error) => {
                console.log(err);
            }
        });
        this.txrwebInstance = txrwebInstance;
    };

    @action
    stopBiz = async (): Promise<any> => {
        // @ts-ignore
        return this.txrwebInstance.stopBiz();
    };

    @action
    updateBiz = async (params: {
        orderNo: string;
        insNo: string;
        tbName: string;
        tbId: string;
        bbName: string;
        bbId: string;
        insStatus: 'no' | 'yes';
    }): Promise<any> => {
        // @ts-ignore
        return this.txrwebInstance.updateBiz(params);
    };
}

export default new RecordStore();
